import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Header from "./component";
import { logout, checkAndOpenSecondaryModal } from "../../au.configuration/actions";
import { resetWishlist } from "../my-wishlist/actions";
import { reloadCarList, resetCarList } from "../car-listing/actions";
import { setTradeInToggleSelected } from "../trade-in-your-car-wrapper/actions";

const mapStateToProps = ({
    user: { profileName, firstName, seoMenu, email, userGeoData},
    preApprovalLoan: {preApproved},
    tradeIn: {userTradeInData},
    myWishlist: {wishlistedCarsList}
}) => ({
    profileName,
    firstName,
    email,
    seoMenu,
    preApproved,
    userTradeInData,
    wishlistedCarsList,
    userGeoData
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    logoutConnect: logout,
    resetWishlistConnect: resetWishlist,
    reloadCarListConnect: reloadCarList,
    resetCarListConnect: resetCarList,
    setTradeInToggleSelectedConnect: setTradeInToggleSelected,
    checkAndOpenSecondaryModalConnect: checkAndOpenSecondaryModal
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Header);
